import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import i18next from 'i18next';

import { getHashParams } from '../utils';
import { LANGUAGE_HASH_PARAM, resources } from '../commons/constants';
import { storeName } from '../store/models/layout.model';

type UseLanguageTypes = {
  setLanguage: (key: string) => void;
};

const useLanguage = (): UseLanguageTypes => {
  const history = useHistory();
  const location = useLocation();

  const locale = useSelector((state) => state[storeName].locale);
  const dispatch = useDispatch()[storeName];

  useEffect(() => {
    if (!location.hash) {
      history.push({
        pathname: location.pathname,
        hash: `#${LANGUAGE_HASH_PARAM}=${locale || resources['vi-VN'].key}`,
        search: location.search,
      });
      return;
    }

    const params = getHashParams(location.hash);
    if (!params[LANGUAGE_HASH_PARAM]) return;
    const foundLang = Object.keys(resources).find((key) => key === params[LANGUAGE_HASH_PARAM]);

    const lang = foundLang || resources['vi-VN'].key;
    if (locale !== lang) dispatch.setLocale(lang);
  }, [location]);

  useEffect(() => {
    if (!locale) return;

    i18next.changeLanguage(locale);
    history.push({
      pathname: location.pathname,
      hash: `#${LANGUAGE_HASH_PARAM}=${locale}`,
      search: location.search,
    });
  }, [locale]);

  const setLanguage = (key: string) => {
    history.push({
      pathname: location.pathname,
      hash: `#${LANGUAGE_HASH_PARAM}=${key}`,
      search: location.search,
    });
    window.location.reload();
  };

  return useMemo(() => ({ setLanguage }), [setLanguage]);
};

export default useLanguage;
